export default __webpack_public_path__ + "static/media/image20.32f57184.svg";